var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnBlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7.7002H16.5C16.7761 7.7002 17 7.92405 17 8.2002V15.2002C17 15.4763 16.7761 15.7002 16.5 15.7002H8.21429C7.36108 15.7002 6.55396 16.072 6 16.7121V8.2002C6 7.92405 6.22386 7.7002 6.5 7.7002ZM4.5 8.2002C4.5 7.09563 5.39543 6.2002 6.5 6.2002H16.5C17.6046 6.2002 18.5 7.09563 18.5 8.2002V15.2002C18.5 16.3048 17.6046 17.2002 16.5 17.2002H8.21429C7.76463 17.2002 7.34122 17.4119 7.07143 17.7716C6.2477 18.8699 4.5 18.2874 4.5 16.9145V8.2002ZM7.5 10.2002C7.5 9.78598 7.83579 9.4502 8.25 9.4502H14.75C15.1642 9.4502 15.5 9.78598 15.5 10.2002C15.5 10.6144 15.1642 10.9502 14.75 10.9502H8.25C7.83579 10.9502 7.5 10.6144 7.5 10.2002ZM7.5 12.9502C7.5 12.536 7.83579 12.2002 8.25 12.2002H12.75C13.1642 12.2002 13.5 12.536 13.5 12.9502C13.5 13.3644 13.1642 13.7002 12.75 13.7002H8.25C7.83579 13.7002 7.5 13.3644 7.5 12.9502Z",
    fill: "#EA7E68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1464 11.9739L10 12.1203V12.3274V14.2027V14.7027H10.5H12.3753H12.5824L12.7288 14.5562L18.2596 9.02548L18.4411 8.84396L18.6131 8.67193L18.7947 8.49041L19.7098 7.57528C20.1001 7.18499 20.1001 6.55336 19.7098 6.16307L18.5396 4.99291C18.1493 4.60262 17.5177 4.60262 17.1274 4.99291L16.2123 5.90804L16.0308 6.08956L15.8587 6.26159L15.6772 6.44311L10.1464 11.9739Z",
    fill: "#EA7E68",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBlog);
export default __webpack_public_path__ + "static/media/icn-blog.d34c2d74b02b90eb1953b2b701d65bb6.svg";
export { ForwardRef as ReactComponent };